import number_format from 'locutus/php/strings/number_format'
import React from 'react'

export function getCurrentTs() {
    return new Date().getTime();
}

export function isExpired(timestamp, minutesToExpire) {
    return timestamp+(minutesToExpire*60*1000) > getCurrentTs();
}

export function myNumberFormat(num, places = 2) {
    let number = Number(num);
    return number_format(number, places, ',', '.')
}

export function calculateStars(bewertungen, themaId = null) {
        let vortrag = 0
        let inhalt = 0
        let referent = 0
        let gesamt = 0
        let vortragCount = 0
        let inahltCount = 0
        let referentCount = 0
        let gesamtCount = 0
        bewertungen.forEach(function(bewertung) {
            if (themaId) {
                if (bewertung.thema_id === themaId) {
                    if (bewertung.vortrag > 0) {
                        vortrag = vortrag + bewertung.vortrag
                        vortragCount = vortragCount+1
                        gesamt = gesamt + bewertung.vortrag
                        gesamtCount = gesamtCount+1
                    }
                    if (bewertung.inhalt > 0) {
                        inhalt = inhalt + bewertung.inhalt
                        inahltCount = inahltCount+1
                        gesamt = gesamt + bewertung.inhalt
                        gesamtCount = gesamtCount+1
                    }
                    if (bewertung.referent > 0) {
                        referent = referent + bewertung.referent
                        referentCount = referentCount+1
                        gesamt = gesamt + bewertung.referent
                        gesamtCount = gesamtCount+1
                    }
                }
            }
        })

        let result = {}
        result.vortrag = vortrag / vortragCount;
        result.inhalt = inhalt / inahltCount;
        result.referent = referent / referentCount;
        result.gesamt = gesamt / gesamtCount;
        result.countVortrag = vortragCount;
        result.countInhalt = inahltCount;
        result.countReferent= referentCount;
        result.countGesamt = gesamtCount;
    return result
}

export function nl2br(string) {
    if (!string) {
        return <div />
    }
    let stringPos = string.split('\n')
    return stringPos.map((str, i) => <div key={i}>{str}</div>)
}




// WEBPACK FOOTER //
// ./src/utils/Utils.js